const removeDuplicates = (elements = []) => {
  if (!elements?.length) {
    return [];
  }

  const seen = new Set();

  return elements.filter(element => {
    const productRef = element?.item?.productRef;
    const itemType = element?.item?.itemType ?? 'OTHER_PRODUCT';
    const isPrimary = element?.isPrimary ?? false;

    if (!productRef) {
      return false;
    }

    const key = `${productRef}:${itemType}:${isPrimary}`;

    if (seen.has(key)) {
      return false;
    }

    seen.add(key);
    return true;
  });
};

export default (ticketProducts = [], formProducts = [], submitted) => {
  if (submitted) {
    return removeDuplicates(ticketProducts);
  }
  const primaryLineItem = [ticketProducts?.find(p => p.isPrimary === true)];

  return removeDuplicates([...primaryLineItem, ...formProducts]);
};
